



























































import Vue from "vue";
import eventBus from "@/services/eventBus";
import CurrentAccountPreAccountingApi from "../services/CurrentAccountPreAccountingApi";
import { CurrentAccountActionRef } from "../models/CurrentAccountPreAccounting";
import { t } from "@/plugins/i18n";

interface Data {
  menuOpen: boolean;
  accDate: string;
  isSaving: boolean;
  confirmToday: boolean;
}

interface Methods {
  save(): void;
  runSave(): Promise<void>;
}

interface Computed {
  todayString: string;
}

interface Props {
  actions: CurrentAccountActionRef[];
  disabled: boolean;
}

/** Mai nap yyyy-MM-dd alakban — a helyi naptár szerint (a v-date-picker is ezt adja) */
function todayIso(): string {
  const now = new Date();
  const month = `${now.getMonth() + 1}`.padStart(2, "0");
  const day = `${now.getDate()}`.padStart(2, "0");
  return `${now.getFullYear()}-${month}-${day}`;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  props: {
    actions: { type: Array as () => CurrentAccountActionRef[], default: () => [] },
    disabled: { type: Boolean, default: false },
  },

  data() {
    return {
      menuOpen: false,
      accDate: "",
      isSaving: false,
      confirmToday: false,
    };
  },

  watch: {
    // Nyitáskor a naptár az első kijelölt művelet dátumára áll (jövőbeli helyett a mai nap)
    menuOpen(open: boolean) {
      this.confirmToday = false;
      if (!open) return;
      const current = String(this.$props.actions[0]?.accDate ?? "").split("T")[0];
      this.accDate = current && current > this.todayString ? this.todayString : current;
    },
  },

  methods: {
    // K2D pb_ok: jövőbeli dátum tiltva (a szerver is ellenőrzi), mai napra megerősítés
    save() {
      if (!this.accDate) return;
      if (this.accDate > this.todayString) {
        eventBus.$emit("error", t("CurrentAccountPreAccounting_JovobeliDatumotNemAdhatMeg"));
        return;
      }
      if (this.accDate === this.todayString) {
        this.confirmToday = true;
        return;
      }
      this.runSave();
    },

    async runSave() {
      this.confirmToday = false;
      this.isSaving = true;
      try {
        const actionIds = this.$props.actions.map((x: CurrentAccountActionRef) => x.id);
        const result = await CurrentAccountPreAccountingApi.changeAccDate(actionIds, this.accDate);

        const failed = result.rows.filter((r) => !r.success);
        if (failed.length === 0) {
          eventBus.$emit("success", t("CurrentAccountPreAccounting_AKonyvelesiDatumModositva"));
        } else {
          const details = failed.map((r) => `${r.actionId}: ${r.message}`).join("; ");
          eventBus.$emit(
            "error",
            t("CurrentAccountPreAccounting_FolyoszamlaMuveletDatumaNemModosult", [failed.length, details])
          );
        }

        // A böngésző a sikeres sorok új dátumát átveszi, és újratölt
        this.$emit("saved", result.rows);
        this.menuOpen = false;
      } catch {
        // A backend üzenetét a globális hibakezelő már megjelenítette
      } finally {
        this.isSaving = false;
      }
    },
  },

  computed: {
    todayString(): string {
      return todayIso();
    },
  },
});
